<div class="tab-box gap-3">
  <div class="d-flex justify-content-center align-items-center tab-item " id="i-4"
    (click)="onDocType('useful_document')" [ngClass]="docType == 'useful_document' ? 'active-tab' : ''"
    matTooltip="This documents are like information document">
    <div class="tab-txt ps-1 ps-sm-2">{{"DOCUMENT.USEFUL"|translate}} {{"DOCUMENT.TEXT"|translate}}</div>
  </div>
  <div class="d-flex justify-content-center align-items-center tab-item " id="i-1"
    matTooltip="Upload contract documents which requires actions like signature, and also ask users to upload necessary documents like Visa"
    [ngClass]="docType == 'action_document' ? 'active-tab' : ''" (click)="onDocType('action_document')">
    <div class="tab-txt ps-1 ps-sm-2">{{"DOCUMENT.ACTION"|translate}} {{"DOCUMENT.TEXT"|translate}}</div>
  </div>
  <div class="d-flex justify-content-center align-items-center tab-item " id="i-1"
    [ngClass]="docType == 'contract_document' ? 'active-tab' : ''" (click)="onDocType('contract_document')"
    matTooltip="Document uploaded by an company regarding the contract">
    <div class="tab-txt ps-1 ps-sm-2">{{"DOCUMENT.CONTRACT"|translate}} {{"DOCUMENT.TEXT"|translate}}</div>
  </div>
  <div class="d-flex justify-content-center align-items-center tab-item" id="i-1"
    [ngClass]="docType == 'course_document' ? 'active-tab' : ''" (click)="onDocType('course_document')"
    matTooltip="Document uploaded by an employee regarding the courses">
    <div class="tab-txt ps-1 ps-sm-2">{{"COURSE.TEXT"|translate}} {{"DOCUMENT.TEXT"|translate}}</div>
  </div>
</div>
<div class=" mt-4   flex-grow-1 d-flex flex-column "
  [ngClass]="docType === 'action_document' || docType === 'course_document' ? 'tab-content p-24' : ''">
  <div class="gap-3 mb-3 d-flex flex-wrap justify-content-between  flex-column-reverse flex-sm-row"
    *ngIf="!isSpinnerLoading">

    <div class="search-cont gap-2 gap-sm-3">
      <div class="s-in form-input me-0" style="position:relative">
        <mat-icon class="input-icon">search</mat-icon>
        <input type="text" placeholder="{{'COMMON.SEARCH' | translate}}" class="form-control" [(ngModel)]="searchInput"
          (input)="onSearch($event)" (keyup.enter)="onGo()" />
      </div>
      <div class="go-b me-0" (click)="onGo()">{{'COMMON.GO' | translate}}</div>
      <div class="s-item d-flex justify-content-center flex-column align-items-center  " (click)="onFilterView()"
        *ngIf="(docType!='useful_document')&&(docType!='contract_document')">
        <img src="assets/images/icons/filter_ic.svg" class="img-fluid">
      </div>
    </div>
    <div *ngIf="docType == 'useful_document'" class="me-0">
      <button mat-raised-button color="primary" class="primary-btn  mb-md-0" type="submit" (click)="onAddUseDocument()">
        <i class="fas fa-plus"></i> {{"COMMON.ADD" | translate}} {{"DOCUMENT.USEFUL"|translate}}
        {{"DOCUMENT.TEXT"|translate}}
      </button>
    </div>
    <div *ngIf="docType == 'contract_document'" class="">
      <button mat-raised-button color="primary" class="primary-btn mb-2 mb-md-0" type="submit"
        (click)="onAddContract()">
        <i class="fas fa-plus"></i> {{"COMMON.ADD" | translate}} {{"DOCUMENT.CONTRACT"|translate}}
      </button>
    </div>
    <div *ngIf="docType == 'action_document'" class="d-flex flex-wrap flex-grow-1 gap-3 action-document">

      <div class="doc-pack group-btn cursor-pointer cs-1 place-center" *ngFor="let item of packArr"
        [ngClass]="{ 'sel-pack': item.selected == true }" (click)="onSelDocPack(item)"> {{ item.p_n }} </div>

      <div class="doc-pack sel-pack cursor-pointer  d-flex align-items-center" (click)="onAddNewDocumentPack()"
        matTooltip="Add New Document Pack">
        <i class="material-icons me-1">add</i> {{"COMMON.ADD" | translate}} {{"DOCUMENT.PACK"|translate}}
      </div>
      <button type="button" class="btn btn-icon p-0  ms-auto d-flex align-items-center"
        matTooltip="You can edit the selected pack" *ngIf="packId" (click)="onEditPack()">
        <img src="assets/images/icons/edit-icon.svg" class="img-fluid me-1" alt="" />
      </button>
      <button type="button" class="btn btn-icon p-0 d-flex align-items-center"
        matTooltip="You can delete the selected pack" *ngIf="packId" (click)="onDeleteItem(packId)">
        <img src="assets/images/icons/delete-icon.svg" class="img-fluid me-1" alt="" />
      </button>
    </div>
  </div>

  <app-filter *ngIf="isFilterShow" (childEvent)="callApi($event)" [fieldCol]="filterArr"></app-filter>  
  <div class="mt-3 flex-grow-1 d-flex align-items-center justify-content-center" style="position: relative"
    *ngIf="isSpinnerLoading">
    <div class="custom-loader"></div>
  </div>
  <div class=" flex-grow-1" *ngIf="docType == 'useful_document' && !isSpinnerLoading">
    <div class="row-r gap-3">
      <div class="pack-box d-flex " *ngFor="let item of usefulDocArr">
        <div class="pack-img place-center"> <img src="assets/images/icons/file_ic.svg" class="img-fluid" alt=""></div>
        <div class="d-flex pack-cont flex-grow-1">
          <div class="ps-2 p-left">
            <div class="d-flex pt-1 price">
              <span class="text-medium ps-1 doc-item">{{ item.tit }}</span>
            </div>
          </div>
          <i class="material-icons cursor-pointer more-icon" [matMenuTriggerFor]="menu">more_vert</i>
          <mat-menu #menu="matMenu">
            <button mat-menu-item color="primary" (click)="onFileDownload(item.document)">
              <img class="me-3" height="15px" src="assets/images/icons/download_ic .svg" alt="">
              <span>{{'BUTTON.DOWNLOAD' | translate}}</span>
            </button>
            <button mat-menu-item color="primary" (click)="onDeleteItem(item.doc_i)">
              <img class="me-3" src="assets/images/icons/delete-icon.svg" alt="">
              <span>{{'BUTTON.DELETE' | translate}}</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
    <div class="mat-table__message" *ngIf="usefulDocArr.length == 0">
      <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="" />
    </div>
  </div>
  <div class=" flex-grow-1" *ngIf="docType == 'contract_document' && !isSpinnerLoading">
    <div class="row-r gap-3">
      <div class="pack-box d-flex  contract-box" *ngFor="let item of contractArr">
        <div class="signed-c" *ngIf="item.signed_count > 0">{{"DOCUMENT.SIGNED"|translate}}</div>
        <div class="pack-img place-center cursor-pointer" (click)="onViewContractDoc(item)"> <img
            src="assets/images/icons/contract_file_ic.svg" class="img-fluid con-i" alt=""></div>
        <div class="d-flex pack-cont flex-grow-1">
          <div class="ps-2 p-left">
            <div class="d-flex pt-1 price">
              <span class="text-medium doc-item ps-1">{{ item.title }}</span>
            </div>
          </div>
          <i class="material-icons cursor-pointer more-icon" [matMenuTriggerFor]="menu">more_vert</i>
          <mat-menu #menu="matMenu">
            <button mat-menu-item color="primary" (click)="onViewSignedContract(item)">
              <mat-icon class="kt-margin-r-0">visibility</mat-icon>
              <span>{{'BUTTON.VIEW' | translate}} {{"DOCUMENT.SIGNED"|translate}}
                {{"DOCUMENT.CONTRACT"|translate}}</span>
            </button>
            <button mat-menu-item color="primary" (click)="onFile(baseUrl,item.document)">
              <mat-icon class="kt-margin-r-0">file_download</mat-icon>
              <span>{{'BUTTON.DOWNLOAD' | translate}}</span>
            </button>
            <button mat-menu-item color="primary" (click)="onDeleteItem(item.document_id)">
              <img class="me-3" src="assets/images/icons/delete-icon.svg" alt="">
              <span>{{'BUTTON.DELETE' | translate}}</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
    <div class="mat-table__message" *ngIf="contractArr.length == 0">
      <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="" />
    </div>
  </div>
  <div class="" *ngIf="docType == 'action_document' && !isSpinnerLoading" class="animate__backInLeft mt-2 ">
    <!-- code for smaller device -->
    <div class="d-block d-sm-none">
      <div class="doc-pack sel-pack cursor-pointer mt-3 mb-3  d-flex align-items-center max-width-btn" st
        (click)="onAddNewDocument()" matTooltip="Add New Document">
        <i class="material-icons me-1">add</i>
        <div class="text"> {{"COMMON.ADD" | translate}} {{"DOCUMENT.TEXT"|translate}}</div>
      </div>
      <div *ngFor="let item of userArr">
        <div class="d-flex align-items-center e-b cursor-pointer" (click)="onSelectActionUser(item)"
          [ngClass]="item.selected ? 'user-sel' : ''">
          <div class="profile-img me-2" [appBackgroundImg]="item.p_pic"></div>
          <div> {{ item.f_n }} {{ item.l_n }}</div>
          <div class="flex-grow-1 pe-2 d-flex d-sm-none align-items-end flex-column" style="text-align:end">
            <mat-icon *ngIf="item.selected">keyboard_arrow_up</mat-icon>
            <mat-icon *ngIf="!item.selected">keyboard_arrow_down</mat-icon>
          </div>
        </div>
        <div *ngIf="item.selected==true" class="mt-3 d-flex flex-column gap-2">
          <div *ngFor="let val of item.doc_d;let i=index" class="d-flex align-items-center">
            <div *ngFor="let doc of packDocDetail.doc">
              <div *ngIf="doc.id==val.doc_id" class="text-black text-semibold m-w-100">{{doc.d_n}}</div>
            </div>
            <div class="d-box" (click)="onUploadDoc(item.e_id, val, item,i)"
              [ngClass]="{ 'u-doc': ((val.data != '')&&!isSignDoc(i,item.doc_id)),'s-doc':isSignDoc(i,item.doc_id) }">
              <i class="material-icons" *ngIf="(val.data == '')&& (!isSignDoc(i,item.doc_id))">add</i>
              <img src="assets/images/documents/upload.svg" *ngIf="(val.data != '' && (!isSignDoc(i,item.doc_id)))"
                class="img-fluid"/>
              <img src="assets/images/documents/sign_doc.png" *ngIf="isSignDoc(i,item.doc_id)" class="img-fluid" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- code for larger devices -->
    <div class="table-wrapper d-none d-sm-block" *ngIf="packDocDetail.doc">
      <table class="w-100">
        <thead>
          <tr>
            <th class="first-col d-flex align-items-center" style="height: 67px">User</th>
            <th class="text-center" *ngFor="let item of packDocDetail.doc">
              {{ item.d_n }}
            </th>
            <th class="text-center  d-flex justify-content-end">
      
              <div class="doc-pack sel-pack cursor-pointer ms-md-2 me-2 me-md-2 d-flex align-items-center max-width-btn"
                (click)="onAddNewDocument()" matTooltip="Add New Document">
                <i class="material-icons me-1">add</i>
                <div class="text"> {{"COMMON.ADD" | translate}} {{"DOCUMENT.TEXT"|translate}}</div>
              </div>
            </th>
          </tr>   
        </thead>
        <tbody *ngIf="userArr.length > 0">
          <tr *ngFor="let item of userArr">
            <td class="first-col d-col d-flex align-items-center">
              <div class="d-flex flex-column flex-md-row align-items-md-center">
                <div class="profile-img me-2 d-none d-sm-block" [appBackgroundImg]="item.p_pic"></div>
                {{ item.f_n }} {{ item.l_n }}
              </div>
            </td>
            <td *ngFor="let val of item.doc_d;let i=index" class="">
              <div class="d-box m-auto" (click)="onUploadDoc(item.e_id, val, item,i)"
                [ngClass]="{ 'u-doc': ((val.data != '')&&!isSignDoc(i,item.doc_id)),'s-doc':isSignDoc(i,item.doc_id) }">
                <i class="material-icons" *ngIf="(val.data == '')&& (!isSignDoc(i,item.doc_id))">add</i>
            
                <img src="assets/images/documents/upload.svg" *ngIf="(val.data != '' && (!isSignDoc(i,item.doc_id)))"
                  class="img-fluid" />
                <img src="assets/images/documents/sign_doc.png" *ngIf="isSignDoc(i,item.doc_id)" class="img-fluid" />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mat-table__message" *ngIf="!packDocDetail">
      <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="" />
    </div>

  </div>
  <div *ngIf="docType == 'course_document' && !isSpinnerLoading"
    class="course-cont flex-wrap flex-sm-nowrap flex-grow-1 d-flex mt-2 ">
    <div class="emp-cont pt-4" *ngIf="empList.length != 0">
      <h6 class="mb-3 ">{{"COMMON.EMPLOYEES" | translate}}</h6>
      <div *ngFor="let item of empList">
        <div class="d-flex align-items-center e-b cursor-pointer" (click)="onSelectUser(item)"
          [ngClass]="item.selected ? 'user-sel' : ''">
          <div class="profile-img me-2" [appBackgroundImg]="item.p_pic"></div>
          <div> {{ item.f_n }} {{ item.l_n }}</div>
          <div class="flex-grow-1 pe-2 d-flex d-sm-none align-items-end flex-column" style="text-align:end">
            <mat-icon *ngIf="item.selected">keyboard_arrow_up</mat-icon>
            <mat-icon *ngIf="!item.selected">keyboard_arrow_down</mat-icon>
          </div>
        </div>
        <!-- UI view changes for smaller devices  -->
        <div class="d-flex d-sm-none flex-column">
          <div [ngTemplateOutlet]="empCourseDoc" *ngIf="item.selected"></div>
        </div>
      </div>
    </div>
    <div class="d-none pt-4 d-sm-flex flex-column ">
      <div [ngTemplateOutlet]="empCourseDoc"></div>
    </div>
    <div class="mat-table__message" *ngIf="empList.length === 0">
      <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="" />
    </div>
  </div>
  <div class="pagination-cont">
    <div class="show-item">
      {{"COMMON.SIP" | translate}}
      <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event)" [(ngModel)]="config.itemsPerPage">
        <option [value]="item" *ngFor="let item of pageSizeOptions">
          {{ item }}
        </option>
      </select>
    </div>
    <div class="page-c">
      <ngb-pagination [collectionSize]="count" [(page)]="config.currentPage" [pageSize]="config.itemsPerPage"
        [maxSize]="maxPaginationSize" (pageChange)="onPageChange($event)"></ngb-pagination>
    </div>
  </div>
  <ng-template #popoverContent>
    <div class="pop-cont">
      <label for="" class="text-center" style="line-height: 19px">
        Are you sure you want to delete this content ?</label>
      <div class="d-flex justify-content-center">
        <button class="btn btn-danger btn-no">Delete</button>
      </div>
    </div>
  </ng-template>
  <ng-template #empCourseDoc>
    <div class="emp-detail pt-4 pt-sm-0 px-sm-3 px-md-4" *ngIf="empCourseData">
      <h6 class="mb-3 " *ngIf="empCourseData.folder.length > 0">
        {{"DOCUMENT.FOLDERS"|translate}}
      </h6>
      <div class="d-flex flex-wrap" *ngIf="empCourseData.folder.length > 0">
        <div class="fol-cont" *ngFor="let item of empCourseData.folder">
          <div class="fol-b d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <div (click)="onViewFolder(item.id, item.employee_id)">
                <img src="assets/images/documents/folder.png" class="img-fluid" />
              </div>
              <div class="ps-2" (click)="onViewFolder(item.id, item.employee_id)">
                <div class="f-h">{{ item.title }}</div>
              </div>
            </div>
            <i class="material-icons cursor-pointer" [matMenuTriggerFor]="menu2">more_vert</i>
            <mat-menu #menu2="matMenu" (click)="onFileDownload(item.document)">
              <button mat-menu-item color="warn" (click)="onDeleteItem(item.id)" type="button">
                <mat-icon class="kt-margin-r-0">delete</mat-icon>
                <span>{{'BUTTON.DELETE' | translate}}</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </div>
      <h6 class="mb-3  mt-2" *ngIf="empCourseData.files.length > 0"> {{"DOCUMENT.FILES"|translate}}</h6>
      <div class="d-flex flex-wrap" *ngIf="empCourseData.files.length > 0">
        <div class="file-b d-flex flex-column" *ngFor="let item of empCourseData.files">
          <div class="file-img flex-grow-1"></div>
          <div class="f-detail d-flex justify-content-between px-2">
            <div class="d-flex">
              <div class="f-img">
                <img src="assets/images/documents/pdf.png" class="img-fluid" />
              </div>
              <div class="ps-2">
                <div class="f-h">{{ item.title }}</div>
              </div>
            </div>
            <i class="material-icons cursor-pointer del-ic" [matMenuTriggerFor]="menu">more_vert</i>
            <mat-menu #menu="matMenu">
              <button mat-menu-item color="warn" (click)="onFileDownload(item.document)" type="button">
                <mat-icon class="kt-margin-r-0">cloud_download</mat-icon>
                <span>{{'BUTTON.DOWNLOAD' | translate}}</span>
              </button>
              <button mat-menu-item color="warn" (click)="onDeleteItem(item.id)" type="button">
                <mat-icon class="kt-margin-r-0">delete</mat-icon>
                <span>{{'BUTTON.DELETE' | translate}}</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>